import axios from 'axios';

export const fetchImageObject = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_REST_API}/fetch-objects?bucket=topship-web`
  );

  return response;
};
